// eslint-disable max-classes-per-file
import React from 'react';

/*
* StoreContext
* Sets up React context Provider & Consumer to House mobx observable store
* */
export const StoreContext = React.createContext(null);
StoreContext.displayName = 'RootStore';

export const StoreProvider = ({ children, store }) => {
    return (
        <StoreContext.Provider value={ store }>
            { children }
        </StoreContext.Provider>
    );
};

/*
* useStore
* Use store Hook used to provide store to functional components.
* @param store - parameter to specify a child store - default is to return the root store.
* */
export const useStore = (store = '') => {
    const rootStore = React.useContext(StoreContext);
    if (!rootStore) {
        throw new Error('useStore must be used within a StoreProvider.');
    }

    if (store) {
        const childStore = rootStore[store];
        if (!childStore) {
            throw new Error(`${ store } is not available in RootStore.`);
        }
        return childStore;
    }
    return store;
};
